WiseMetering.Views.DestroySeu = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.seus.destroy')
});
